import { memo } from "react";

import config from "../Config/config";

const Version = () => {
    return (
        <pre>
            {config.version}
        </pre>
    );
}

export default memo(Version);